import script from "./StreamingQuestion.vue?vue&type=script&setup=true&lang=js"
export * from "./StreamingQuestion.vue?vue&type=script&setup=true&lang=js"

import "./StreamingQuestion.vue?vue&type=style&index=0&id=8dc9eac4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8dc9eac4"]])

export default __exports__